<template>
  <div class="parent playback-v2" style="font-family: 'Poppins', sans-serif">
    <div class="containerx">
      <div class="date-input-wrapper p-5">
        <b-card class="date-input-card">
          <div class="page-title mb-3">
            <h1>Track Replay</h1>
          </div>
          <div class="date-input">
            <b-row class="d-flex justify-content-center align-items-center">
              <b-col md="3" sm="12" class="my-2">
                <label>Device</label>
                <span class="device-name d-block p-2">{{
                  `${
                    typeof gps.device_name !== 'undefined'
                      ? gps.device_name
                      : 'Loading ...'
                  } (IMEI: ${imei})`
                }}</span>
                <!-- <v-select
                v-model="input.device"
                :options="deviceList"
                @search="searchDevice"
                class="device"
                :disabled="true"
              /> -->
              </b-col>
              <b-col md="3" sm="12" class="my-2">
                <label>Start Time</label>
                <flat-pickr
                  class="date-picker form-control"
                  :config="{
                    enableTime: true,
                    dateFormat: 'Y-m-d H:i',
                    minDate: last90days,
                    time_24hr: true,
                    defaultHour: 0
                  }"
                  v-model="input.start"
                />
              </b-col>
              <b-col md="3" sm="12" class="my-2">
                <label>End Time</label>
                <flat-pickr
                  class="date-picker form-control"
                  :config="{
                    enableTime: true,
                    dateFormat: 'Y-m-d H:i',
                    minDate: last90days,
                    time_24hr: true,
                    defaultHour: 23,
                    defaultMinute: 59
                  }"
                  v-model="input.end"
                />
              </b-col>
              <b-col md="3" sm="12" class="my-2 align-self-end">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  block
                  class="mb-1 p-2 vs-con-loading__container"
                  id="btn-cari"
                  @click="getTrack"
                >
                  Search
                </b-button>
              </b-col>
            </b-row>

            <!-- For Mobile -->
            <div class="data-cell-mobile d-lg-none p-5">
              <div class="d-flex mileage-moving justify-content-around mb-5">
                <div class="mileage d-flex align-items-center">
                  <div class="icon mr-2">
                    <img src="@/assets/images/tabler-icon/route.svg" />
                  </div>
                  <div class="value">
                    <span class="d-block title">Mileage</span>
                    <span class="d-block subtitle">
                      <b-skeleton-wrapper :loading="loading">
                        <template #loading>
                          <div>
                            <b-skeleton
                              animation="fade"
                              width="auto"
                            ></b-skeleton>
                          </div>
                        </template>
                        {{
                          totalMileage
                            .toString()
                            .replace('.', ',')
                            .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
                        }}
                        Km
                      </b-skeleton-wrapper>
                    </span>
                  </div>
                </div>

                <span class="divider"></span>

                <div class="moving d-flex align-items-center">
                  <div class="icon mr-2">
                    <img src="@/assets/images/tabler-icon/clock.svg" />
                  </div>
                  <div class="value">
                    <span class="d-block title">Moving Time</span>
                    <span class="d-block subtitle">
                      <b-skeleton-wrapper :loading="loading">
                        <template #loading>
                          <div>
                            <b-skeleton
                              animation="fade"
                              width="auto"
                            ></b-skeleton>
                          </div>
                        </template>
                        <!-- {{ dateTimeToHm(total_time) }} -->
                        <!-- {{ total_time }} -->
                        {{ secondToHms(calcTime()) }}
                      </b-skeleton-wrapper>
                    </span>
                  </div>
                </div>
              </div>

              <div class="address">
                <div class="timeline">
                  <div class="timeline-wrapper">
                    <ul class="timeline-sessions">
                      <li class="session-1">
                        <div class="session-title text-muted">
                          Start Location
                        </div>
                        <template v-if="address.from.length > 80">
                          <span class="session-subtitle d-block">
                            {{ address.from.substring(0, 45) }}...
                            <a
                              class="address-detail"
                              v-b-modal.lokasi-awal-popup
                            >
                              <em>See Detail</em>
                            </a>
                          </span>
                        </template>
                        <template v-else>
                          <span class="session-subtitle d-block">
                            <b-skeleton-wrapper :loading="loading">
                              <template #loading>
                                <div>
                                  <b-skeleton
                                    animation="fade"
                                    class="mb-3 mt-3"
                                    width="auto"
                                  ></b-skeleton>
                                  <b-skeleton
                                    animation="fade"
                                    width="60%"
                                  ></b-skeleton>
                                </div>
                              </template>
                              {{ address.from }}
                            </b-skeleton-wrapper>
                          </span>
                        </template>
                        <span class="session-time text-muted mt-1 d-block">
                          {{ start_time }}
                        </span>
                      </li>

                      <li class="session-2">
                        <div class="session-title text-muted">
                          Finish Location
                        </div>
                        <template v-if="address.destination.length > 80">
                          <span class="session-subtitle d-block">
                            {{ address.destination.substring(0, 45) }}...
                            <a
                              class="address-detail"
                              v-b-modal.lokasi-akhir-popup
                            >
                              <em>See Detail</em>
                            </a>
                          </span>
                        </template>
                        <template v-else>
                          <span class="session-subtitle d-block">
                            <b-skeleton-wrapper :loading="loading">
                              <template #loading>
                                <div>
                                  <b-skeleton
                                    animation="fade"
                                    class="mb-3 mt-3"
                                    width="auto"
                                  ></b-skeleton>
                                  <b-skeleton
                                    animation="fade"
                                    width="60%"
                                  ></b-skeleton>
                                </div>
                              </template>
                              {{ address.destination }}
                            </b-skeleton-wrapper>
                          </span>
                        </template>
                        <span class="session-time text-muted mt-1 d-block">
                          {{ end_time }}
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="total-mileage text-right d-lg-none">
                Vehicle Millage:
                <span class="m-number">
                  {{
                    mileage.current
                      .toString()
                      .replace('.', ',')
                      .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
                  }}
                  Km
                </span>
              </div>
            </div>

            <div class="range d-flex align-items-center px-5 mt-5 d-lg-none">
              <button class="btn-play" @click="togglePlay">
                <img
                  v-if="!this.play"
                  src="@/assets/images/tabler-icon/edited/player-play-blue.svg"
                />
                <img
                  v-else
                  src="@/assets/images/tabler-icon/edited/player-pause-blue.svg"
                />
              </button>

              <vs-slider :max="slider.max" v-model="slider.step" class="mx-5" />

              <div
                class="next-track d-flex align-items-center"
                style="color: #1da1f2"
              >
                <button
                  class="btn-next-track d-flex align-items-center mr-2"
                  @click="set_speed()"
                >
                  <img
                    src="@/assets/images/tabler-icon/edited/player-track-next-blue.svg"
                  />
                </button>
                <span>X{{ speed_now }}</span>
              </div>
            </div>
          </div>
        </b-card>
      </div>

      <l-map
        class="map"
        ref="peta"
        :zoom="map.zoom"
        :center="map.center"
        :options="{ zoomControl: false }"
      >
        <l-tile-layer
          v-for="tileProvider in tileProviders"
          :key="tileProvider.name"
          :name="tileProvider.name"
          :visible="tileProvider.visible"
          :url="tileProvider.url"
          :attribution="tileProvider.attribution"
          layer-type="base"
          :options="{ maxZoom: 22 }"
        />

        <!-- Start Sign -->
        <l-marker
          :lat-lng="markerStart.position"
          :icon="markerStart.icon"
          :visible="markerStart.visible"
        >
          <l-popup>
            <div class="popup-data">
              <div
                class="header-popup p-3"
                style="
                  background: green;
                  color: #fff;
                  font-weight: 600;
                  font-size: 15px;
                  font-family: 'Poppins', sans-serif;
                "
              >
                Start
              </div>
              <div
                class="content-popup p-3"
                style="font-family: 'Poppins', sans-serif"
              >
                <p>
                  {{ address.from }}
                </p>
              </div>
            </div>
          </l-popup>
        </l-marker>

        <!-- Finish Sign -->
        <l-marker
          :lat-lng="markerFinish.position"
          :icon="markerFinish.icon"
          :visible="markerFinish.visible"
        >
          <l-popup>
            <div class="popup-data">
              <div
                class="header-popup p-3"
                style="
                  background: #ea5455;
                  color: #fff;
                  font-weight: 600;
                  font-size: 15px;
                  font-family: 'Poppins', sans-serif;
                "
              >
                Finish
              </div>
              <div
                class="content-popup p-3"
                style="font-family: 'Poppins', sans-serif"
              >
                <p>
                  {{ address.destination }}
                </p>
              </div>
            </div>
          </l-popup>
        </l-marker>

        <!-- Moving Marker -->
        <l-marker
          v-for="(item, index) in dataMarkerMoving"
          :key="'Moving' + index"
          :lat-lng="latLngx(item.lat, item.lon)"
          :icon="markerMoving.icon"
          :visible="movingSwitch"
          @click="showAddress(item.lat, item.lon)"
        >
          <l-popup>
            <template class="popup-data">
              <div
                class="header-popup p-3 d-flex justify-content-between"
                style="
                  background: #1da1f2;
                  color: #fff;
                  font-weight: 600;
                  font-size: 15px;
                  font-family: 'Poppins', sans-serif;
                "
              >
                <span>Moving</span>
                <div
                  class="mr-lg-3 d-flex align-items-center gap-3"
                  style="font-weight: 400; font-size: 13px"
                >
                  <div class="d-flex">
                    <img
                      class="align-items-center mr-1"
                      src="@/assets/images/tabler-icon/edited/speed-white.svg"
                    />
                    <span class="align-items-center"
                      >{{ item.speed }} km/h
                    </span>
                  </div>
                  <div class="d-flex">
                    <img
                      class="d-flex align-self-center mr-1"
                      src="@/assets/images/tabler-icon/edited/clock-white.svg"
                    />
                    <span>{{ getTime(item.time) }}</span>
                  </div>
                </div>
              </div>
              <div
                class="content-popup p-3"
                style="font-family: 'Poppins', sans-serif"
              >
                <p>{{ bangke }}</p>
              </div>
            </template>
          </l-popup>
        </l-marker>

        <!-- Alert Marker -->
        <l-marker
          v-for="(item, index) in dataMarkerAlert"
          :key="'Alert' + index"
          :lat-lng="latLngx(item.lat, item.lon)"
          :icon="markerAlert.icon"
          :visible="alertSwitch"
          @click="showAddress(item.lat, item.lon)"
        >
          <l-popup>
            <template class="popup-data">
              <div
                class="header-popup p-3 d-flex justify-content-between"
                style="
                  background: #db4437;
                  color: #fff;
                  font-weight: 600;
                  font-size: 15px;
                "
              >
                <div
                  class="mr-lg-3 d-flex align-items-center gap-1"
                  style="
                    font-weight: 400;
                    font-size: 13px;
                    font-family: 'Poppins', sans-serif;
                  "
                >
                  <span class="d-flex align-items-center">Alert</span>
                  <img
                    class="d-flex align-items-center"
                    src="@/assets/images/tabler-icon/edited/bell-ringing-white.svg"
                  />
                  <span> </span>
                </div>
              </div>
              <div
                class="content-popup p-3"
                style="font-family: 'Poppins', sans-serif"
              >
                <p>{{ bangke }}</p>
              </div>
            </template>
          </l-popup>
        </l-marker>

        <!-- Parking Marker -->
        <l-marker
          v-for="(item, index) in dataMarkerParking"
          :key="'Parking' + index"
          :lat-lng="latLngx(item.lat, item.lon)"
          :icon="markerParking.icon"
          :visible="parkingSwitch"
          @click="showAddress(item.lat, item.lon)"
        >
          <l-popup>
            <div class="popup-data" style="font-family: 'Poppins', sans-serif">
              <div
                class="header-popup p-3 d-flex justify-content-between"
                style="
                  background: #4b465c;
                  color: #fff;
                  font-weight: 600;
                  font-size: 15px;
                "
              >
                <span>Parking</span>
                <div
                  class="mr-lg-3 d-flex align-items-center gap-1"
                  style="font-weight: 400; font-size: 13px"
                >
                  <img
                    class="d-flex align-self-center"
                    src="@/assets/images/tabler-icon/edited/clock-white.svg"
                  />
                  <span>
                    <!-- {{ convertSecToMin(data.duration) }} -->
                    {{ getTime(item.time) }}
                  </span>
                </div>
              </div>
              <div class="content-popup p-3">
                <p>
                  {{ bangke }}
                </p>
              </div>
            </div>
          </l-popup>
        </l-marker>

        <!-- Stop Marker -->
        <l-marker
          v-for="(item, index) in dataMarkerStop"
          :key="'Stop' + index"
          :lat-lng="latLngx(item.lat, item.lon)"
          :icon="markerStop.icon"
          :visible="stopSwitch"
          @click="showAddress(item.lat, item.lon)"
        >
          <l-popup>
            <div class="popup-data" style="font-family: 'Poppins', sans-serif">
              <div
                class="header-popup p-3 d-flex justify-content-between"
                style="
                  background: #4b465c;
                  color: #fff;
                  font-weight: 600;
                  font-size: 15px;
                "
              >
                <span>Stop</span>
                <div
                  class="mr-lg-3 d-flex align-items-center gap-1"
                  style="font-weight: 400; font-size: 13px"
                >
                  <img
                    class="d-flex align-self-center"
                    src="@/assets/images/tabler-icon/edited/clock-white.svg"
                  />
                  <span>
                    <!-- {{ convertSecToMin(data.duration) }} -->
                    {{ getTime(item.time) }}
                  </span>
                </div>
              </div>
              <div class="content-popup p-3">
                <p>{{ bangke }}</p>
              </div>
            </div>
          </l-popup>
        </l-marker>

        <!-- <l-layer-group> -->
        <!-- <l-polyline
          :lat-lngs="polyline.latlngs"
          :color="polyline.color"
          :weight="polyline.weight"
        >
        </l-polyline> -->
        <!-- <l-polyline :lat-lngs="polyline" color="purple"> </l-polyline> -->

        <l-polyline
          v-for="(polyline, index) in generatePolylines()"
          :key="'Polyline' + index"
          :lat-lngs="polyline.latlngs"
          :options="{ color: polyline.color, weight: 5 }"
        ></l-polyline>
        <!-- </l-layer-group> -->

        <l-rotated-marker
          v-for="(item, index) in markers"
          :key="'angle' + index"
          :lat-lng="item.position"
          :icon="item.icon"
          :rotationAngle="item.angle"
          :visible="item.visible"
        >
        </l-rotated-marker>

        <!-- For Mobile -->
        <l-control position="topright" class="d-flex gap-3 d-lg-none">
          <div
            class="filter-status-btn d-flex align-items-center p-3"
            v-b-modal.chart-popup
          >
            <feather-icon icon="ActivityIcon" />
          </div>

          <b-modal
            id="chart-popup"
            modal-class="chart-popup"
            header-class="chart-header"
            header-text-variant="light"
            hide-header
            hide-footer
            hide-header-close
            centered
          >
            <b-button
              class="close-modal-btn"
              @click="$bvModal.hide('chart-popup')"
            >
              X
            </b-button>

            <!-- <div class="button-nav text-center">
              <button
                :class="{
                  activeBtn: activeTab === 'allChart'
                }"
                class="btn btn-all"
                @click="activeTab = 'allChart'"
              >
                All
              </button>
              <button
                :class="{
                  activeBtn: activeTab === 'speedChart'
                }"
                class="btn btn-speed"
                @click="activeTab = 'speedChart'"
              >
                Speed
              </button>
              <button
                :class="{
                  activeBtn: activeTab === 'fuelChart'
                }"
                class="btn btn-fuel"
                @click="activeTab = 'fuelChart'"
              >
                Fuel
              </button>
              <button
                :class="{
                  activeBtn: activeTab === 'tempChart'
                }"
                class="btn btn-temp"
                @click="activeTab = 'tempChart'"
              >
                Temperature
              </button>
            </div> -->

            <div class="data-chart">
              <!-- <div class="all-data-chart" v-if="activeTab === 'allChart'"> -->
              <div class="all-data-chart">
                <vue-apex-charts
                  :type="chartOptions.chart.type"
                  height="165"
                  :options="chartOptions"
                  :series="series"
                ></vue-apex-charts>
              </div>
              <!-- <div class="speed-data-chart" v-if="activeTab === 'speedChart'">
                <vue-apex-charts
                  :type="chartOptions.chart.type"
                  height="165"
                  :options="chartOptions"
                  :series="seriesSpeed"
                ></vue-apex-charts>
              </div>
              <div class="fuel-data-chart" v-if="activeTab === 'fuelChart'">
                <vue-apex-charts
                  :type="chartOptions.chart.type"
                  height="165"
                  :options="chartOptions"
                  :series="seriesFuel"
                ></vue-apex-charts>
              </div>
              <div class="temp-data-chart" v-if="activeTab === 'tempChart'">
                <vue-apex-charts
                  :type="chartOptions.chart.type"
                  height="165"
                  :options="chartOptions"
                  :series="seriesTemp"
                ></vue-apex-charts>
              </div> -->
            </div>
          </b-modal>

          <vs-dropdown vs-custom-content vs-trigger-click>
            <div class="filter-status-btn d-flex align-items-center p-3">
              <feather-icon icon="FilterIcon" />
            </div>
            <vs-dropdown-menu>
              <div class="list-group">
                <b-list-group flush>
                  <b-list-group-item
                    class="d-flex justify-content-between align-items-center"
                  >
                    <span>Moving Point</span>
                    <vs-switch
                      v-model="movingSwitch"
                      color="#1da1f2"
                      class="switch-button"
                      name="switch-button"
                    />
                  </b-list-group-item>

                  <b-list-group-item
                    class="d-flex justify-content-between align-items-center"
                  >
                    <span>Stop Point</span>
                    <vs-switch
                      v-model="stopSwitch"
                      color="#4B465C"
                      class="switch-button"
                      name="switch-button"
                    />
                  </b-list-group-item>

                  <b-list-group-item
                    class="d-flex justify-content-between align-items-center"
                  >
                    <span>Parking Point</span>
                    <vs-switch
                      v-model="parkingSwitch"
                      color="#4B465C"
                      class="switch-button"
                      name="switch-button"
                    />
                  </b-list-group-item>

                  <b-list-group-item
                    class="d-flex justify-content-between align-items-center"
                  >
                    <span>Alert Point</span>
                    <vs-switch
                      v-model="alertSwitch"
                      color="danger"
                      class="switch-button"
                      name="switch-button"
                    />
                  </b-list-group-item>
                </b-list-group>
              </div>
            </vs-dropdown-menu>
          </vs-dropdown>
        </l-control>

        <l-control position="topleft" class="polygone-wrapper">
          <button
            class="btn_poi"
            @click="showPolygone('speed_zone')"
            :style="
              show_hide.speed_zone ? 'background: #1da1f2' : 'background: #fff'
            "
          >
            <img src="@/assets/images/tabler-icon/Speedometer.svg" />
          </button>
          <button
            class="btn_poi"
            @click="showPolygone('geofence')"
            :style="
              show_hide.geofence ? 'background: #1da1f2' : 'background: #fff'
            "
          >
            <img src="@/assets/images/tabler-icon/map-2.svg" />
          </button>
          <button
            class="btn_poi"
            @click="showPolygone('poi')"
            type="filled"
            :style="show_hide.poi ? 'background: #1da1f2' : 'background: #fff'"
          >
            <img src="@/assets/images/tabler-icon/map-pin.svg" />
          </button>
        </l-control>

        <l-polygon
          v-for="(item, index) in zone_speed.polygon"
          :key="'B' + index"
          :lat-lngs="item.latlngs"
          :color="item.color"
          :fillColor="item.color"
          :visible="show_hide.speed_zone == true"
        >
          <l-popup>
            <div class="leaflet-popup-header">Speed By Zone</div>
            <table class="leaflet-popup-table">
              <tr>
                <td>Zone Name</td>
                <td>{{ item.name }}</td>
              </tr>
              <tr>
                <td>Speed Limit</td>
                <td>{{ item.speed }} Km/h</td>
              </tr>
            </table>
          </l-popup>
        </l-polygon>

        <l-polygon
          v-for="(item, index) in geofence.polygon_in"
          :key="'IN' + index"
          :lat-lngs="item.latlngs"
          :color="item.color"
          :fillColor="item.color"
          :visible="show_hide.geofence == true"
        >
          <l-popup>
            <div class="leaflet-popup-header">Geofence Zone</div>
            <table class="leaflet-popup-table">
              <tr>
                <td>Geofence Name</td>
                <td>{{ item.name }}</td>
              </tr>
              <tr>
                <td>Geofence Type</td>
                <td>{{ item.type }}</td>
              </tr>
            </table>
          </l-popup>
        </l-polygon>

        <l-polygon
          v-for="(item, index) in geofence.polygon_out"
          :key="'OUT' + index"
          :lat-lngs="item.latlngs"
          :color="item.color"
          :fillColor="item.color"
          :visible="show_hide.geofence == true"
        >
          <l-popup>
            <div class="leaflet-popup-header">Geofence Zone</div>
            <table class="leaflet-popup-table">
              <tr>
                <td>Geofence Name</td>
                <td>{{ item.name }}</td>
              </tr>
              <tr>
                <td>Geofence Type</td>
                <td>{{ item.type }}</td>
              </tr>
            </table>
          </l-popup>
        </l-polygon>

        <l-polygon
          v-for="(item, index) in poi.polygon"
          :key="'A' + index"
          :lat-lngs="item.latlngs"
          :visible="show_hide.poi == true"
        >
          <l-popup>
            <div class="leaflet-popup-header">Point of Interest</div>
            <table class="leaflet-popup-table">
              <tr>
                <td>POI Name</td>
                <td>{{ item.name }}</td>
              </tr>
            </table>
          </l-popup>
        </l-polygon>
        <l-marker
          v-for="(item, index) in poi.marker"
          :key="'A1' + index"
          :lat-lng="item.latlngs"
          :icon="item.icon"
          :visible="show_hide.poi == true"
        >
          <l-tooltip
            :options="{
              interactive: true,
              direction: 'top'
            }"
            >{{ item.name }}</l-tooltip
          >
        </l-marker>

        <l-control position="topright" class="d-flex switch-wrapper">
          <div class="switch p-3" style="font-family: 'Poppins', sans-serif">
            <vs-switch
              v-model="movingSwitch"
              color="#1da1f2"
              class="switch-button"
              name="switch-button"
            />
            <span>Moving Point</span>
          </div>

          <div class="switch p-3" style="font-family: 'Poppins', sans-serif">
            <vs-switch
              v-model="stopSwitch"
              color="#4B465C"
              class="switch-button"
              name="switch-button"
            />
            <span>Stop Point</span>
          </div>

          <div class="switch p-3" style="font-family: 'Poppins', sans-serif">
            <vs-switch
              v-model="parkingSwitch"
              color="#4B465C"
              class="switch-button"
              name="switch-button"
            />
            <span>Parking Point</span>
          </div>

          <div class="switch p-3" style="font-family: 'Poppins', sans-serif">
            <vs-switch
              v-model="alertSwitch"
              color="danger"
              class="switch-button"
              name="switch-button"
            />
            <span>Alert Point</span>
          </div>
        </l-control>
        <l-control-layers position="topright"></l-control-layers>
        <l-control-zoom position="topright"></l-control-zoom>
      </l-map>

      <div class="bottom-bar">
        <template v-if="vehicleInfoSwitch">
          <div class="px-5">
            <!-- For Default Size -->
            <div class="data-cell d-flex align-items-center">
              <div class="mileage-moving p-5">
                <div class="mileage d-flex">
                  <div class="icon mr-2">
                    <img src="@/assets/images/tabler-icon/route.svg" />
                  </div>
                  <div class="value">
                    <span class="d-block title">Mileage</span>
                    <span class="d-block subtitle">
                      <b-skeleton-wrapper :loading="loading">
                        <template #loading>
                          <div>
                            <b-skeleton
                              animation="fade"
                              width="auto"
                            ></b-skeleton>
                          </div>
                        </template>
                        {{
                          totalMileage
                            .toString()
                            .replace('.', ',')
                            .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
                        }}
                        Km
                      </b-skeleton-wrapper>
                    </span>
                  </div>
                </div>
                <hr />
                <div class="moving d-flex">
                  <div class="icon mr-2">
                    <img src="@/assets/images/tabler-icon/clock.svg" />
                  </div>
                  <div class="value">
                    <span class="d-block title">Moving Time</span>
                    <span class="d-block subtitle">
                      <b-skeleton-wrapper :loading="loading">
                        <template #loading>
                          <div>
                            <b-skeleton
                              animation="fade"
                              width="auto"
                            ></b-skeleton>
                          </div>
                        </template>
                        <!-- {{ dateTimeToHm(total_time) }} -->
                        <!-- {{ total_time }} -->
                        {{ secondToHms(calcTime()) }}
                      </b-skeleton-wrapper>
                    </span>
                  </div>
                </div>
              </div>

              <div class="address">
                <div class="timeline">
                  <div class="timeline-wrapper">
                    <ul class="timeline-sessions">
                      <li class="session-1">
                        <div class="session-title text-muted">
                          Start Location
                          <img
                            src="@/assets/images/tabler-icon/dashed.svg"
                            class="dashed ml-2 mb-1"
                          />
                        </div>
                        <template v-if="address.from.length > 38">
                          <span class="session-subtitle d-block">
                            {{ address.from.substring(0, 38) }}...
                            <a
                              class="address-detail"
                              v-b-modal.lokasi-awal-popup
                              @click="$bvModal.hide('lokasi-akhir-popup')"
                            >
                              <em>See Detail</em>
                            </a>
                          </span>
                        </template>
                        <template v-else>
                          <span class="session-subtitle d-block">
                            <b-skeleton-wrapper :loading="loading">
                              <template #loading>
                                <div>
                                  <b-skeleton
                                    animation="fade"
                                    class="mb-3 mt-3"
                                    width="auto"
                                  ></b-skeleton>
                                  <b-skeleton
                                    animation="fade"
                                    width="60%"
                                  ></b-skeleton>
                                </div>
                              </template>
                              {{ address.from }}
                            </b-skeleton-wrapper>
                          </span>
                        </template>
                        <span class="session-time text-muted mt-1 d-block">
                          {{ start_time }}
                        </span>
                      </li>

                      <li class="session-2">
                        <div class="session-title text-muted">
                          Finish Location
                        </div>
                        <template v-if="address.destination.length > 38">
                          <span class="session-subtitle d-block">
                            {{ address.destination.substring(0, 38) }}...
                            <a
                              class="address-detail"
                              v-b-modal.lokasi-akhir-popup
                              @click="$bvModal.hide('lokasi-awal-popup')"
                            >
                              <em>See Detail</em>
                            </a>
                          </span>
                        </template>
                        <template v-else>
                          <span class="session-subtitle d-block">
                            <b-skeleton-wrapper :loading="loading">
                              <template #loading>
                                <div>
                                  <b-skeleton
                                    animation="fade"
                                    class="mb-3 mt-3"
                                    width="auto"
                                  ></b-skeleton>
                                  <b-skeleton
                                    animation="fade"
                                    width="60%"
                                  ></b-skeleton>
                                </div>
                              </template>
                              {{ address.destination }}
                            </b-skeleton-wrapper>
                          </span>
                        </template>
                        <span class="session-time text-muted mt-1 d-block">
                          {{ end_time }}
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>

                <b-modal
                  id="lokasi-awal-popup"
                  modal-class="lokasi-awal-popup"
                  header-class="lokasi-awal-header"
                  header-text-variant="light"
                  title="Start Location"
                  hide-footer
                  hide-header-close
                >
                  <b-button
                    class="close-modal-btn"
                    @click="$bvModal.hide('lokasi-awal-popup')"
                  >
                    X
                  </b-button>
                  <div class="lokasi-awal-detail px-2">
                    {{ address.from }}
                  </div>
                </b-modal>

                <b-modal
                  id="lokasi-akhir-popup"
                  modal-class="lokasi-akhir-popup"
                  header-class="lokasi-akhir-header"
                  header-text-variant="light"
                  title="Finish Location"
                  hide-footer
                  hide-header-close
                >
                  <b-button
                    class="close-modal-btn"
                    @click="$bvModal.hide('lokasi-akhir-popup')"
                  >
                    X
                  </b-button>
                  <div class="lokasi-akhir-detail px-2">
                    {{ address.destination }}
                  </div>
                </b-modal>
              </div>
            </div>
          </div>
        </template>

        <div class="toggle-button mr-3">
          <!-- <button class="toggle-info px-5 py-1">
            <div class="d-flex gap-3">
              Show Info
              <vs-switch
                v-model="vehicleInfoSwitch"
                color="#28c76f"
                class="info-button"
                name="switch-button"
              />
            </div>
          </button> -->
          <!-- @click="toggleVehicleInfo" -->

          <!-- <div
            class="switch p-3 d-block"
            style="font-family: 'Poppins', sans-serif"
          >
            <vs-switch
              v-model="vehicleInfoSwitch"
              color="#4B465C"
              class="switch-button"
              name="switch-button"
            />
            <span>Titik Stop</span>
          </div> -->

          <button class="toggle-sidebar px-5 py-1 ml-3" @click="toggleSidebar">
            <img
              src="@/assets/images/tabler-icon/edited/chevron-down-white.svg"
            />
          </button>
        </div>

        <div class="content-bottom-bar">
          <div
            class="head-bottom-bar py-3 px-5 d-flex justify-content-between align-items-center"
          >
            <div class="button-nav">
              <button class="toggle-info px-5 py-1">
                <div class="d-flex gap-3">
                  Show Address Info
                  <vs-switch
                    v-model="vehicleInfoSwitch"
                    color="#28c76f"
                    class="info-button"
                    name="switch-button"
                  />
                </div>
              </button>
              <!-- <button
                :class="{
                  activeBtn: activeTab === 'allChart'
                }"
                class="btn btn-all"
                @click="activeTab = 'allChart'"
              >
                All
              </button>
              <button
                :class="{
                  activeBtn: activeTab === 'speedChart'
                }"
                class="btn btn-speed"
                @click="activeTab = 'speedChart'"
              >
                Speed
              </button>
              <button
                :class="{
                  activeBtn: activeTab === 'fuelChart'
                }"
                class="btn btn-fuel"
                @click="activeTab = 'fuelChart'"
              >
                Fuel
              </button>
              <button
                :class="{
                  activeBtn: activeTab === 'tempChart'
                }"
                class="btn btn-temp"
                @click="activeTab = 'tempChart'"
              >
                Temperature
              </button> -->
            </div>

            <div class="range d-flex align-items-center px-5">
              <button class="btn-play" @click="togglePlay">
                <img
                  v-if="!this.play"
                  src="@/assets/images/tabler-icon/edited/player-play-blue.svg"
                />
                <img
                  v-else
                  src="@/assets/images/tabler-icon/edited/player-pause-blue.svg"
                />
              </button>

              <vs-slider :max="slider.max" v-model="slider.step" class="mx-5" />

              <div
                class="next-track d-flex align-items-center"
                style="color: #1da1f2"
              >
                <button
                  class="btn-next-track d-flex align-items-center mr-2"
                  @click="set_speed()"
                >
                  <img
                    src="@/assets/images/tabler-icon/edited/player-track-next-blue.svg"
                  />
                </button>
                <span>X{{ speed_now }}</span>
              </div>
            </div>

            <div class="total-mileage">
              Vehicle Millage:
              <span class="m-number"
                >{{
                  mileage.current
                    .toString()
                    .replace('.', ',')
                    .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
                }}
                Km
              </span>
            </div>
          </div>

          <div class="data-chart">
            <div class="all-data-chart">
              <!-- <div class="all-data-chart" v-if="activeTab === 'allChart'"> -->
              <vue-apex-charts
                :type="chartOptions.chart.type"
                height="165"
                :options="chartOptions"
                :series="series"
              ></vue-apex-charts>
            </div>
            <!-- <div class="speed-data-chart" v-if="activeTab === 'speedChart'">
              <vue-apex-charts
                ref="chart"
                type="area"
                height="165"
                :options="chartOptions"
                :series="seriesSpeed"
              ></vue-apex-charts>
            </div> -->
            <!-- <div class="fuel-data-chart" v-if="activeTab === 'fuelChart'">
              <vue-apex-charts
                :type="area"
                height="165"
                :options="chartOptions"
                :series="seriesFuel"
              ></vue-apex-charts>
            </div> -->
            <!-- <div class="temp-data-chart" v-if="activeTab === 'tempChart'">
              <vue-apex-charts
                :type="area"
                height="165"
                :options="chartOptions"
                :series="seriesTemp"
              ></vue-apex-charts>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  LMap,
  LTileLayer,
  LCircle,
  LMarker,
  LControl,
  LControlLayers,
  LControlZoom,
  LPopup,
  LIcon,
  LTooltip,
  LPolyline,
  LLayerGroup,
  LPolygon
} from 'vue2-leaflet'
import 'leaflet/dist/leaflet.css'
import L from 'leaflet'
import { Icon } from 'leaflet'
import LRotatedMarker from 'vue2-leaflet-rotatedmarker'

delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})

import {
  BCard,
  BCardTitle,
  BCardText,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
  BFormDatepicker,
  BDropdown,
  BDropdownItem,
  BModal,
  VBModal
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'

import VueApexCharts from 'vue-apexcharts'

export default {
  components: {
    LMap,
    LTileLayer,
    LCircle,
    LMarker,
    LControl,
    LControlLayers,
    LControlZoom,
    LPopup,
    LIcon,
    LTooltip,
    LPolyline,
    LRotatedMarker,
    LLayerGroup,
    LPolygon,
    BCard,
    BCardTitle,
    BCardText,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    vSelect,
    BFormDatepicker,
    flatPickr,
    BDropdown,
    BDropdownItem,
    BModal,
    VueApexCharts
  },

  directives: {
    Ripple,
    'b-modal': VBModal
  },

  data() {
    return {
      active: false,
      url: 'https://www.google.com/maps/vt?lyrs=m@189&gl=en&x={x}&y={y}&z={z}',
      zoom: 17,
      center: [-6.1779895, 106.8128504],

      map: {
        center: L.latLng(-6.21011, 106.832459),
        zoom: 13
      },

      mapOptions: {
        // zoomSnap: 0.5
      },

      tileProviders: [
        {
          name: 'Google Street',
          visible: true,
          url: 'https://www.google.com/maps/vt?lyrs=m@189&gl=en&x={x}&y={y}&z={z}',
          attribution: 'google'
        },
        {
          name: 'Google Satellites',
          visible: false,
          url: 'https://www.google.com/maps/vt?lyrs=s@189&gl=en&x={x}&y={y}&z={z}',
          attribution: 'google'
        },
        {
          name: 'Google Hybrid',
          visible: false,
          url: 'https://www.google.com/maps/vt?lyrs=s,h@189&gl=en&x={x}&y={y}&z={z}',
          attribution: 'google'
        },
        {
          name: 'Google Terrain',
          visible: false,
          url: 'https://www.google.com/maps/vt?lyrs=p@189&gl=en&x={x}&y={y}&z={z}',
          attribution: 'google'
        },
        {
          name: 'Google Traffic',
          visible: false,
          url: 'https://www.google.com/maps/vt?lyrs=m@221097413,traffic&x={x}&y={y}&z={z}',
          attribution: 'google'
        },
        {
          name: 'OpenStreetMap',
          visible: false,
          attribution:
            '&copy; <a target="_blank" href="https://osm.org/copyright">OpenStreetMap</a> contributors',
          url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
        }
      ],

      movingSwitch: false,
      stopSwitch: true,
      parkingSwitch: true,
      alertSwitch: false,
      vehicleInfoSwitch: true,

      vehicleInfo: true,

      publicPath: process.env.BASE_URL,
      data: [],
      actor: {},
      imei: '',
      gps: {},
      token: '',

      input: {
        // device: '',
        start: '',
        end: ''
      },

      export: {
        // device: '',
        start: '',
        end: ''
      },

      tracks: [],
      markers: [],

      trackType: 'line',
      defaultPolyline: [],
      // greenPolyline: [],
      // bluePolyline: [],
      // yellowPolyline: [],
      // redPolyline: [],

      // getColorPolyline: [],

      // polyline: [],

      polyline: {
        latlngs: [],
        color: '#1DA1F2',
        weight: 5,
        speed: []
      },

      // greenPolyline: {
      //   latlngs: [],
      //   color: '#28C76F',
      //   weight: 5
      // },

      // green: '#28C76F',
      // blue: '#1DA1F2',
      // defaultDots: [],
      // dots: [],

      dataMarkerMoving: [],
      dataMarkerAlert: [],
      dataMarkerParking: [],
      dataMarkerStop: [],

      alamat: '',

      markerStart: {
        position: L.latLng(0, 0),
        icon: L.icon({
          iconUrl: process.env.BASE_URL + 'markers/start.svg',
          iconSize: [32, 32],
          iconAnchor: [16, 16]
        }),
        visible: false
      },

      markerFinish: {
        position: L.latLng(0, 0),
        icon: L.icon({
          iconUrl: process.env.BASE_URL + 'markers/finish.svg',
          iconSize: [32, 32],
          iconAnchor: [16, 16]
        }),
        visible: false
      },

      markerMoving: {
        position: L.latLng(0, 0),
        icon: L.icon({
          iconUrl: process.env.BASE_URL + 'markers/moving.svg',
          iconSize: [32, 40],
          iconAnchor: [16, 40]
        }),
        visible: false
      },

      markerAlert: {
        position: L.latLng(0, 0),
        icon: L.icon({
          iconUrl: process.env.BASE_URL + 'markers/alert.svg',
          iconSize: [32, 40],
          iconAnchor: [16, 40]
        }),
        visible: false
      },

      markerParking: {
        position: L.latLng(0, 0),
        icon: L.icon({
          iconUrl: process.env.BASE_URL + 'markers/parking.svg',
          iconSize: [32, 40],
          iconAnchor: [16, 40]
        }),
        visible: false
      },

      markerStop: {
        position: L.latLng(0, 0),
        icon: L.icon({
          iconUrl: process.env.BASE_URL + 'markers/stop.svg',
          iconSize: [32, 40],
          iconAnchor: [16, 40]
        }),
        visible: false
      },

      play: false,
      slider: {
        max: 50,
        step: 0,
        step_temp: 0,
        time: '',
        speed: 0,
        lat: '',
        lon: ''
      },

      speed_track: 1000,
      speed_now: 1,
      class_animation: true,

      interval: '',
      notify: 'Server Error',
      loading: false,

      // defaultStopSign: [],
      // stopSign: [],

      poi: {
        marker: [],
        polygon: []
      },

      zone_speed: {
        polygon: []
      },

      geofence: {
        polygon_in: [],
        polygon_out: []
      },

      show_hide: {
        poi: false,
        geofence: false,
        speed_zone: false
      },

      show_hide_color: {
        poi: 'white',
        geofence: 'white',
        speed_zone: 'white'
      },

      stopPark: false,
      stopParkNumber: 0,
      stopParkStatus: '',
      last_map_position: [],
      temp_angle: 0,

      address: {
        from: '',
        destination: ''
      },

      bangke: '',

      totalMileage: 0,
      mileage: {
        current: 0,
        total: 0
      },

      start_time: '',
      end_time: '',
      total_time: null,
      time_point: '',

      seriesAll: [
        {
          name: 'Speed',
          data: [31, 40, 28, 51, 42, 109, 100]
        },
        {
          name: 'Fuel',
          data: [11, 32, 45, 32, 34, 52, 41]
        },
        {
          name: 'Temperature',
          data: [15, 22, 35, 37, 31, 57, 47]
        }
      ],
      seriesSpeed: [
        // {
        //   name: 'Speed',
        //   data: [31, 40, 28, 51, 42, 109, 100]
        // }
      ],
      seriesFuel: [
        // {
        //   name: 'Fuel',
        //   data: [11, 32, 45, 32, 34, 52, 41]
        // }
      ],
      seriesTemp: [
        // {
        //   name: 'Temperature',
        //   data: [15, 22, 35, 37, 31, 57, 47]
        // }
      ],
      series: [],

      chartOptions: {
        chart: {
          id: 'mychart',
          height: 165,
          type: 'area',
          zoom: {
            enabled: true
          },
          toolbar: {
            show: true
          }
        },
        // colors: ['#FF9F43'],
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'straight'
        },
        title: {
          text: '',
          align: 'left'
        },
        xaxis: {
          // type: 'datetime',
          categories: [],
          tickPlacement: 'on',
          tickAmount: 6
        },
        yaxis: {
          show: true,
          tickAmount: 5
        },
        noData: {
          text: 'No Data'
        },
        legend: {
          show: true
        }
      },
      activeTab: 'allChart',
      value1: 72
    }
  },

  // mounted() {

  // },

  computed: {
    last90days() {
      const date = new Date()
      date.setDate(date.getDate() - 90)

      return date
    },

    step() {
      if (
        this.slider.step_temp == this.slider.step ||
        this.slider.step_temp + 1 == this.slider.step ||
        this.slider.step_temp - 1 == this.slider.step
      )
        this.class_animation = true
      else this.class_animation = false

      this.slider.step_temp = this.slider.step
      return this.slider.step
    }
  },

  watch: {
    step(val) {
      if (this.tracks.length > 0) {
        const data = this.tracks[val]
        // const dataAfter = this.tracks[val+1]
        // console.log(data)
        this.slider.time = data.time
        this.slider.speed = data.speed
        this.slider.lat = parseFloat(data.lat)
        this.slider.lon = parseFloat(data.lon)
        this.map.center = L.latLng(parseFloat(data.lat), parseFloat(data.lon))

        // if(val == 0)
        //   this.mileage.total = 0
        // else if(val > oldVal)
        //   this.mileage.total = this.mileage.total + parseInt(data.mileage - this.tracks[val-1].mileage)
        // else {
        //   this.mileage.total = this.mileage.total - parseInt(this.tracks[val+1].mileage - data.mileage)
        // }

        this.mileage.current = (data.mileage / 1000).toFixed(2)

        // this.mileage.total = this.mileage.current + ((data.mileage-this.tracks[val-1].mileage)/1000).toFixed(2)
        // this.mileage.current = (data.mileage/1000).toFixed(2)

        // this.polyline = this.defautlPolyline.slice(0, val + 1)
        // this.dots = this.defaultDots.slice(0, val)

        // this.stopSign = this.defaultStopSign.filter((l, i) => {
        // return l.index <= val
        // })

        // this.defaultStopSign.filter((l, i) => {
        //   if (l.position.lng == data.lon) this.stopSign.push(l)
        // })

        // this.polyline.push(L.latLng(data.lat, data.lon))
        // this.map.center = L.latLng(data.lat, data.lon)
        this.markers[0].position = L.latLng(data.lat, data.lon)
        this.markers[0].angle = data.angle
        this.last_map_position = [
          {
            lat: parseFloat(data.lat),
            lon: parseFloat(data.lon)
          }
        ]

        let animasi =
          this.class_animation && this.speed_now == 1
            ? 'animation-icon'
            : this.class_animation && this.speed_now == 2
            ? 'animation-icon_speed2'
            : this.class_animation && this.speed_now == 3
            ? 'animation-icon_speed3'
            : 'animation-icon-default'

        this.markers[0].icon = L.icon({
          iconUrl: `${this.gps.fullpath_icon.acc_on}`,
          iconSize: [32, 32],
          className:
            data.angle - this.temp_angle > 50 ||
            data.angle - this.temp_angle < -50
              ? ''
              : animasi
        })
        this.temp_angle = data.angle
      }
    },

    play() {
      // if (this.stopPark) {
      //   this.stopPark = false
      //   this.slider.step = 0
      //   this.stopSign = []
      // }

      if (this.play) {
        this.interval = setInterval(() => {
          if (this.slider.step < this.slider.max) {
            this.slider.step++
          } else {
            this.play = false
            // this.slider.step = 0
            clearInterval(this.interval)
          }
        }, this.speed_track)
      } else {
        if (this.interval) clearInterval(this.interval)
      }
    },

    speed_now: {
      handler(val) {
        this.play = !this.play
      }
    }
  },

  created() {
    this.imei = this.$route.params.imei
    this.token =
      localStorage.getItem('userInfo') !== null
        ? JSON.parse(localStorage.getItem('userInfo')).token
        : ''
    this.$http
      .get(`${this.$api.endpoint}/user/profile`, {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      })
      .then((res) => {
        this.actor = res.data.message.data
        this.getGpsDetail()
        this.getZoneSpeedList()
        this.getPoiList()
        this.getGeofenceZone()

        let today = new Date()
        let date = `${today.getFullYear()}-${(today.getMonth() + 1)
          .toString()
          .padStart(2, '0')}-${today.getDate().toString().padStart(2, '0')}`

        this.input.start = `${date} 00:00`
        // this.input.end = `${date} ${today.getHours().toString().padStart(2, '0')}:${today.getMinutes().toString().padStart(2, '0')}`
        this.input.end = `${date} 23:59`

        // this.input.start = '2020-02-12 20:00'
        // this.input.end = '2020-02-13 12:00'
      })
      .catch((error) => {
        this.$gf.httpErrorHandler(error)
      })
  },

  // mounted() {},

  methods: {
    // getPolylineColor(speed) {
    //   if (speed <= 30) {
    //     return 'green'
    //   } else if (speed <= 60) {
    //     return 'yellow'
    //   } else {
    //     return 'red'
    //   }
    // },
    // generatePolylines() {
    //   const polylines = []
    //   for (let i = 0; i < this.polyline.latlngs.length - 1; i++) {
    //     const latlngs = [this.polyline.latlngs[i], this.polyline.latlngs[i + 1]]
    //     const color = this.getColor(this.polyline.speed[i])
    //     polylines.push({ latlngs, color })
    //   }
    //   console.log(this.polyline.speed)
    //   return polylines
    // },
    // getColor(speed) {
    //   if (speed >= 0 && speed <= 30) {
    //     return '#28C76F'
    //   } else if (speed >= 31 && speed <= 60) {
    //     return '#1DA1F2'
    //   } else if (speed >= 61 && speed <= 100) {
    //     return '#FF9F43'
    //   } else if (speed > 100) {
    //     return '#db4437'
    //   }
    // },

    generatePolylines() {
      const polylines = []
      const latlngsArr = this.polyline.latlngs
      const colorsArr = latlngsArr.map((latlng, i) =>
        this.getColor(this.polyline.speed[i])
      )

      for (let i = 0, len = latlngsArr.length - 1; i < len; i++) {
        const latlngs = [latlngsArr[i], latlngsArr[i + 1]]
        const color = colorsArr[i]
        polylines.push({ latlngs, color })
      }
      return polylines
    },

    getColor(speed) {
      const colors = [
        { speed: 0, color: '#28C76F' }, // Speed range 1
        { speed: 31, color: '#1DA1F2' }, // Speed range 2
        { speed: 61, color: '#FF9F43' }, // Speed range 3
        { speed: Infinity, color: '#db4437' } // Speed greater than 100
      ]

      for (let i = 0; i < colors.length; i++) {
        if (speed <= colors[i].speed) {
          return colors[i].color
        }
      }
    },

    toggleVehicleInfo() {
      this.vehicleInfo = !this.vehicleInfo
    },

    // getDataDevice(keyword) {
    //   this.$http
    //     .get(
    //       `${this.$api.endpoint}/tracking/search?keyword=${keyword}&type=vehicle`,
    //       {
    //         headers: {
    //           Authorization: `Bearer ${this.token}`
    //         }
    //       }
    //     )
    //     .then((res) => {
    //       this.deviceList = res.data.message.data
    //     })
    //     .catch((error) => {
    //       this.$gf.httpErrorHandler(error)
    //     })
    // },

    // searchDevice(keyword) {
    //   if (this.actor.privilege >= 4) {
    //     this.getDataDevice(keyword)
    //   } else {
    //     if (keyword.length >= 3) {
    //       this.getDataDevice(keyword)
    //     } else {
    //       this.deviceList = []
    //     }
    //   }
    // },

    getGpsDetail() {
      this.$http
        .get(`${this.$api.endpoint}/gps/detail/${this.imei}`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          this.gps = res.data.message.data
          // this.map.center = L.latLng(this.gps.lat, this.gps.lon)
          this.getTrack()
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    latLngx(lat, lon) {
      return L.latLng(lat, lon)
    },

    getZoneSpeedList() {
      this.$http
        .get(`${this.$api.endpoint}/speed_limit_by_zone/all_zone`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          var data = res.data.message.data
          //console.log(data)

          data.map((item, index) => {
            let target = 'polygon'
            let latlngs = this.geomToPolygon(item.geom)

            this.zone_speed[target].push({
              id: item.id,
              name: item.name,
              speed: item.speed,
              latlngs: latlngs,
              center: L.latLng(item.lat, item.lon),
              color: '#B8860B'
            })
          })
        })
        .catch((error) => {})
    },

    getGeofenceZone() {
      this.$http
        .get(`${this.$api.endpoint}/zone/geofence_zone`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          var data = res.data.message.data

          data.map((item, index) => {
            let target = item.type == 0 ? 'polygon_in' : 'polygon_out'
            let latlngs = this.geomToPolygon(item.geom)

            this.geofence[target].push({
              id: item.id,
              name: item.name,
              latlngs: latlngs,
              center: L.latLng(item.lat, item.lon),
              color: item.type == 0 ? 'red' : 'green',
              type: item.type == 0 ? 'IN' : 'OUT'
            })
          })
        })
        .catch((error) => {})
    },

    getPoiList() {
      this.$http
        .get(`${this.$api.endpoint}/poi/general`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          var data = res.data.message.data
          //console.log(data)

          data.map((item, index) => {
            let target = item.type === 0 ? 'marker' : 'polygon'
            let latlngs =
              item.type === 0
                ? L.latLng(item.lat, item.lon)
                : this.geomToPolygon(item.geom)

            this.poi[target].push({
              id: item.id,
              name: item.name,
              latlngs: latlngs,
              center: L.latLng(item.lat, item.lon),
              icon: item.icon
                ? L.icon({
                    iconUrl: `${
                      item.icon.fullpath_icon
                        ? item.icon.fullpath_icon
                        : item.icon.icon
                    }`,
                    iconSize: [20, 20]
                  })
                : L.icon.Default
            })
          })
        })
        .catch((error) => {})
    },

    showPolygone(params) {
      this.show_hide[params] = !this.show_hide[params]
      if (this.show_hide[params] == true)
        this.show_hide_color[params] = 'primary'
      else this.show_hide_color[params] = 'white'
    },

    geomToPolygon(geom) {
      let start = '(('
      let end = '))'

      geom = geom.substring(
        geom.indexOf(start) + start.length,
        geom.indexOf(end)
      )

      let latlon = geom.split(',')

      let result = []
      latlon.map((item) => {
        let x = item.split(' ')
        result.push([parseFloat(x[1]), parseFloat(x[0])])
      })

      return result
    },

    getTrack() {
      this.loading = true
      this.$vs.loading({
        background: 'success',
        color: '#fff',
        container: '#btn-cari',
        scale: 0.45
      })

      this.markers = []
      this.tracks = []
      this.polyline.latlngs = []
      // this.polyline = []
      this.defaultPolyline = []
      this.play = false
      // this.defaultStopSign = []
      // this.stopSign = []

      this.slider.time = '-'
      this.slider.speed = '-'
      this.slider.step = 0
      this.loading = true
      // this.stopPark = false
      this.temp_angle = 0

      this.dataMarkerMoving = []
      this.dataMarkerAlert = []
      this.dataMarkerParking = []
      this.dataMarkerStop = []

      this.chartOptions = {
        ...this.chartOptions,
        ...{
          noData: {
            text: 'Loading....'
          },
          xaxis: {
            categories: []
          }
        }
      }

      this.series = []

      this.$http
        .get(`${this.$api.endpoint}/tracking/track/${this.imei}`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          },
          params: {
            // device: this.input.device ? this.input.device.value : '',
            start: `${this.input.start}:00`,
            end: `${this.input.end}:00`
          }
        })
        .then((res) => {
          this.$vs.loading.close(`#btn-cari > .con-vs-loading`)
          this.loading = false

          // this.output.device = this.input.device
          this.export.start = this.input.start
          this.export.end = this.input.end

          if (res.data.message.data.length > 0) {
            this.tracks = res.data.message.data

            this.start_time = this.tracks[0].time
            this.end_time = this.tracks[this.tracks.length - 1].time
            // this.total_time = this.end_time - this.start_time
            // console.log(this.total_time)
            this.time_point = this.tracks.time

            this.totalMileage = (
              (this.tracks[this.tracks.length - 1].mileage -
                this.tracks[0].mileage) /
              1000
            ).toFixed(2)

            this.mileage.current = (this.tracks[0].mileage / 1000).toFixed(2)

            this.getAddress(
              { lat: this.tracks[0].lat, lon: this.tracks[0].lon },
              'address',
              'from'
            )
            this.getAddress(
              {
                lat: this.tracks[this.tracks.length - 1].lat,
                lon: this.tracks[this.tracks.length - 1].lon
              },
              'address',
              'destination'
            )

            var dataChart = res.data.message.data_chart

            this.chartOptions = {
              ...this.chartOptions,
              ...{
                // chart: {
                //   zoom: {
                //     enabled: true,
                //     type: 'x',
                //     autoScaleYaxis: true,
                //     zoomedArea: {
                //       fill: {
                //         color: '#90CAF9',
                //         opacity: 0.4
                //       },
                //       stroke: {
                //         color: '#0D47A1'
                //       }
                //     }
                //   }
                // },
                colors: ['#1DA1F2', '#FF9F43'],
                xaxis: {
                  type: 'category',
                  categories: dataChart.category.time,
                  tickPlacement: 'between',
                  tickAmount: 7,
                  labels: {
                    show: true,
                    // offsetX: 5, // adjust the offset of the x-axis label
                    rotate: -0
                    // hideOverlappingLabels: false
                  }
                }
                // yaxis: {
                //   show: true,
                //   tickAmount: 5
                // }
              }
            }

            this.series = [
              {
                name: 'Speed(km/h)',
                data: dataChart.series.speed
              },
              {
                name: 'Temperature(°C)',
                data: dataChart.series.temperature
              }
            ]

            // this.seriesSpeed = [
            //   {
            //     name: 'Speed(km/h)',
            //     data: dataChart.series.speed
            //   }
            // ]

            // this.seriesTemp = [
            //   {
            //     name: 'Temperature(°C)',
            //     data: dataChart.series.temperature
            //   }
            // ]

            this.slider.lat = this.tracks[0].lat
            this.slider.lon = this.tracks[0].lon

            this.slider.max = this.tracks.length - 1
            this.slider.time =
              this.tracks.length > 0 ? this.tracks[0].time : '-'
            this.slider.speed =
              this.tracks.length > 0 ? this.tracks[0].speed : '0'

            let lastStop = false
            let lastPark = false
            const lastData = {
              speed: '',
              time: '',
              acc: ''
            }

            this.stopParkNumber = 0
            this.stopParkStatus = ''

            this.dots = []
            this.defaultDots = []

            // init start marker
            ;(this.markerStart.position = L.latLng(
              this.tracks[0].lat,
              this.tracks[0].lon
            )),
              (this.markerStart.visible = true)

            // init finish marker
            ;(this.markerFinish.position = L.latLng(
              this.tracks[this.tracks.length - 1].lat,
              this.tracks[this.tracks.length - 1].lon
            )),
              (this.markerFinish.visible = true)

            this.tracks.map((item, index) => {
              this.defaultPolyline.push(L.latLng(item.lat, item.lon))
              // this.defaultPolyline.push(item.speed)
              this.polyline.speed.push(item.speed)

              // console.log(this.defaultPolyline)

              let x = {
                position: L.latLng(item.lat, item.lon)
              }
              // this.defaultDots.push(x)

              // init moving marker
              if (item.speed > 0 && item.acc === 1) {
                this.dataMarkerMoving.push({
                  lat: item.lat,
                  lon: item.lon,
                  speed: item.speed,
                  time: item.time
                })
              }
              // init alert marker
              if (item.alert > 0) {
                this.dataMarkerAlert.push({
                  lat: item.lat,
                  lon: item.lon,
                  time: item.time
                })
              }
              // init parking marker
              if (item.acc === 0 && item.speed === 0) {
                this.dataMarkerParking.push({
                  lat: item.lat,
                  lon: item.lon,
                  time: item.time
                })
              }
              // init stop marker
              if (item.acc === 1 && item.speed === 0) {
                this.dataMarkerStop.push({
                  lat: item.lat,
                  lon: item.lon,
                  time: item.time
                })
              }

              lastData.time = item.time
              lastData.speed = item.speed
            })

            const data = this.tracks[0]

            this.polyline.latlngs = this.defaultPolyline
            // this.polyline = this.defaultPolyline
            this.map.center = L.latLng(data.lat, data.lon)

            const x = {
              visible: true,
              position: L.latLng(data.lat, data.lon),
              angle: data.angle
            }

            if (this.gps.icon)
              x.icon = L.icon({
                iconUrl: `${this.gps.fullpath_icon.acc_on}`,
                iconSize: [32, 32]
              })
            else {
              x.icon = L.icon.Default
            }

            this.markers.push(x)

            this.last_map_position = [
              {
                lat: parseFloat(this.tracks[0].lat),
                lon: parseFloat(this.tracks[0].lon)
              }
            ]
          }

          // if (this.defaultStopSign.length > 0) {
          //   this.defaultStopSign = this.defaultStopSign.filter(
          //     (list_stop_park) => list_stop_park.total_time >= 60
          //   )
          // }
          // console.log(this.tracks)
        })
        .catch((error) => {
          this.loading = false
          this.$vs.loading.close(`#btn-cari > .con-vs-loading`)
          this.$gf.httpErrorHandler(error)
          console.log(error)
        })
    },

    // search() {
    //   this.loading = true
    //   this.$vs.loading({
    //     background: 'success',
    //     color: '#fff',
    //     container: '#btn-cari',
    //     scale: 0.45
    //   })

    //   // this.output.device = this.input.device
    //   this.output.start_time = this.input.start_time
    //   this.output.end_time = this.input.end_time

    //   this.getGpsDetail()
    //   // this.getTrack()
    // },

    getAddress(latlng, target, index) {
      this.$http
        .get(`${this.$api.base_url}/api/address`, {
          params: {
            latitude: latlng.lat,
            longitude: latlng.lon
          }
        })
        .then((res) => {
          this[target][index] = res.data.message
        })
    },

    showAddress(lat, lon) {
      this.bangke = ''

      this.$http
        .get(`${this.$api.base_url}/api/address`, {
          params: {
            latitude: lat,
            longitude: lon
          }
        })
        .then((res) => {
          this.bangke = res.data.message
        })
    },

    // dateTimeToHm() {
    //   var currentDate = new Date(time)
    //   let hourMin =
    //     currentDate.getHours() + ' Jam ' + currentDate.getMinutes() + ' Menit'
    //   return hourMin
    // },

    // formatDate(date) {
    //   let d = new Date(date)
    //   hour = '' + d.getHours()
    //   minute = '' + d.getMinutes()
    //   second = '' + d.getSeconds()

    //   const options = { day: 'numeric', month: 'long', year: 'numeric' }
    //   return d.toLocaleDateString('en-US', options)
    // },

    getTime(time) {
      let timePoint = new Date(time)
      let sumTime = timePoint.toLocaleTimeString()

      return sumTime
    },

    calcTime() {
      let startDate = new Date(this.start_time)
      let endDate = new Date(this.end_time)
      let totalTime = endDate.getTime() - startDate.getTime()

      return totalTime
    },

    secondToHms(seconds) {
      seconds = Number(seconds)

      let hour = Math.floor((seconds / (1000 * 60 * 60)) % 24)
      let minute = Math.floor((seconds / (1000 * 60)) % 60)
      let sec = Math.floor((seconds / 1000) % 60)

      let displayHours = hour + (minute > 0 ? ' Jam' : ' Jam')
      let displayMinutes = minute + (sec > 0 ? ' Menit' : ' Menit')

      return displayHours + ' ' + displayMinutes
    },

    togglePlay() {
      this.play = !this.play
    },

    set_speed() {
      this.play = !this.play
      if (this.speed_now < 3) {
        this.speed_now++
        this.speed_track = this.speed_track / this.speed_now
      } else {
        this.speed_now = 1
        this.speed_track = 1000
      }
    },

    toggleSidebar() {
      var bottomBar = document.querySelector('.bottom-bar')
      var toggleBtn = document.querySelector('.toggle-sidebar')
      bottomBar.classList.toggle('active')
      toggleBtn.classList.toggle('opened')
    }
  }
}
</script>

<style>
.report-popup-wrapper .form-control,
.form-control:disabled,
.form-control[readonly] {
  background-color: #fff !important;
}

.flatpickr-calendar .flatpickr-day.selected {
  background-color: #1da1f2 !important;
  border-color: #1da1f2 !important;
}

.playback-v2 .vs-slider {
  height: 10px;
  border-radius: 6px;
  background: #fff;
}

.vs-slider-primary .vs-circles-slider {
  border: 3px solid #1da1f2;
}

.vs-slider-primary .vs-slider-line-one {
  background: linear-gradient(45deg, #1da1f2 0%, #1da1f2 0.01%, #62c1fc 100%);
}

.vs-slider--circle {
  width: 16px;
  height: 16px;
  margin-top: 3px;
  border-radius: 50%;
}

.vs-slider--circles.isEndValue {
  border-radius: 50% !important;
}

.chart-popup .modal-content {
  border: none;
}

.chart-popup .chart-header {
  background-color: #28c76f;
}

.chart-popup h5 {
  color: #fff;
}

#chart-popup .close-modal-btn {
  position: absolute;
  top: -20px;
  right: -9px;
  background-color: #fff;
  color: #4b465c;
  font-weight: 800;
  box-shadow: 0px 2px 4px rgba(165, 163, 174, 0.3);
  border-radius: 6px;
  border: none;
}

#chart-popup .close-modal-btn:hover {
  background-color: #e6e6e6;
}
.lokasi-awal-popup .modal-content {
  border: none;
}

.lokasi-awal-popup .lokasi-awal-header {
  background-color: #28c76f;
}

.lokasi-awal-popup h5 {
  color: #fff;
}

#lokasi-awal-popup .close-modal-btn {
  position: absolute;
  top: -62px;
  right: -9px;
  background-color: #fff;
  color: #4b465c;
  font-weight: 800;
  box-shadow: 0px 2px 4px rgba(165, 163, 174, 0.3);
  border-radius: 6px;
  border: none;
}

#lokasi-awal-popup .close-modal-btn:hover {
  background-color: #e6e6e6;
}

.lokasi-akhir-popup .modal-content {
  border: none;
}

.lokasi-akhir-popup .lokasi-akhir-header {
  background-color: #ea5455;
}

.lokasi-akhir-popup h5 {
  color: #fff;
}

#lokasi-akhir-popup .close-modal-btn {
  position: absolute;
  top: -62px;
  right: -9px;
  background-color: #fff;
  color: #4b465c;
  font-weight: 800;
  box-shadow: 0px 2px 4px rgba(165, 163, 174, 0.3);
  border-radius: 6px;
  border: none;
}

#lokasi-akhir-popup .close-modal-btn:hover {
  background-color: #e6e6e6;
}

.address-detail {
  text-decoration: underline;
}

.animation-icon {
  transition-duration: 1s;
  transition-timing-function: linear;
}

.animation-icon_speed2 {
  transition-duration: 0.5s;
  transition-timing-function: linear;
}

.animation-icon_speed3 {
  transition-duration: 0.2s;
  transition-timing-function: linear;
}

.animation-icon-default {
  /* transition-duration: 0.5s; */
  transition-timing-function: linear;
}

/* For Mobile */

.data-cell-mobile {
  border: 1px solid rgba(60, 60, 60, 0.26);
  border-radius: 6px;
}

.data-cell-mobile .mileage-moving .divider {
  width: 1px;
  background: rgba(60, 60, 60, 0.26);
}

.filter-status-btn {
  background: linear-gradient(45deg, #1da1f2 0%, #1da1f2 0.01%, #62c1fc 100%);
  box-shadow: 0px 2px 4px rgba(165, 163, 174, 0.3);
  border-radius: 8px;
  color: #fff;
}

.list-group {
  width: 200px;
}

.list-group span.num {
  color: #1da1f2;
  font-weight: 600;
}

.list-group .switch-button {
  border-radius: 25px;
}

/* Extra small devices (phones, 576px and down) */
@media only screen and (max-width: 576px) {
  .bottom-bar,
  .switch-wrapper {
    display: none !important;
  }

  .containerx {
    position: inherit !important;
    height: auto !important;
    overflow: hidden;
    display: inherit !important;
  }

  .address {
    width: 100% !important;
  }

  .timeline ul {
    display: flex !important;
    flex-direction: column !important;
    gap: 10px !important;
  }

  .timeline li.session-1 {
    border-left: 1px dashed #4b465c;
  }

  .timeline li.session-2 {
    margin-left: 10px;
  }

  .range {
    width: auto !important;
  }
}

/* Small devices (portrait tablets and large phones, 576px and up) */
@media only screen and (min-width: 576px) and (max-width: 768px) {
  .bottom-bar,
  .switch-wrapper {
    display: none !important;
  }
  .containerx {
    position: inherit !important;
    height: auto !important;
    overflow: hidden;
    display: inherit !important;
  }

  .address {
    width: 100% !important;
  }

  .range {
    width: auto !important;
  }
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) and (max-width: 992px) {
  .bottom-bar,
  .switch-wrapper {
    display: none !important;
  }
  .containerx {
    position: inherit !important;
    height: auto !important;
    overflow: hidden;
    display: inherit !important;
  }

  .address {
    width: 100% !important;
  }

  .range {
    width: auto !important;
  }
}

/* Large devices (laptops/desktops, 992px and up) */
/* @media only screen and (min-width: 992px) {
} */

/* Extra large devices (large laptops and desktops, 1200px and up) */
/* @media only screen and (min-width: 1200px) {
} */
</style>

<style lang="scss" scoped>
@media only screen and (max-width: 600px) {
  .vue2leaflet-map {
    &.leaflet-container {
      height: 500px !important;
    }
  }
}
.vue2leaflet-map {
  &.leaflet-container {
    height: 100vh;
  }
}

.parent {
  font-family: 'Poppins', sans-serif;
  background-color: #fff;
}

.containerx {
  position: relative;
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.date-input .device-name {
  border: 1px solid #b0b0b0;
  border-radius: 4px;
  background-color: #f8f8f8;
  opacity: 1;
  font-weight: 400;
}

.date-input-card {
  border: none;
  border-radius: 12px;
  box-shadow: 0px 2px 4px rgba(165, 163, 174, 0.3);
}

.page-title h1 {
  font-weight: 600;
  font-size: 18px;
  color: inherit;
}

#btn-cari {
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)),
    #28c76f;
  border: none;
  box-shadow: 0px 2px 4px rgba(165, 163, 174, 0.3);
  border-radius: 6px;
}

.form-control {
  background-color: #fff;
}

.map .switch {
  margin-inline: 10px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0px 2px 4px rgba(165, 163, 174, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

.map .switch span {
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  font-size: 13px;
}

.map .switch .switch-button {
  border-radius: 25px;
}

// bottom bar CSS

.data-cell {
  width: auto;
  // width: 621px;
  // width: 750px;
  height: auto;
  z-index: 99999;
  position: absolute;
  bottom: 230px;
  background: #ffffff;
  /* Light/Gray/Gray - SM */

  box-shadow: 0px 2px 4px rgba(165, 163, 174, 0.3);
  border-radius: 8px;
}

.address {
  width: 540px;
}

.timeline ul {
  display: flex;
  flex-direction: row;
}

.timeline ul,
.timeline li {
  list-style: none;
  padding: 0;
}

.timeline .timeline-wrapper {
  padding: 10px;
}

.timeline .timeline-sessions {
  position: relative;
}

.timeline .session-title {
  font-weight: 400;
  font-size: 0.929rem;
}

.timeline .session-subtitle {
  font-weight: 600;
  font-size: 1.071rem;
}

.timeline .session-time {
  font-weight: 400;
  font-size: 0.929rem;
}

.timeline li.session-1 {
  // padding-bottom: 1.5rem;
  // border-bottom: 1px dashed #4b465c;
  position: relative;
  padding-left: 20px;
  margin-left: 10px;
  // width: 450px !important;

  &:last-child {
    border: 0px;
    padding-bottom: 0;
  }

  &:before {
    content: '';
    width: 15px;
    height: 15px;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.25)),
      #28c76f;
    box-shadow: 0px 0px 0px 4px rgba(40, 199, 111, 0.2);
    border-radius: 50%;
    position: absolute;
    left: -8px;
    top: 0px;
  }
}

.timeline li.session-2 {
  // padding-bottom: 1.5rem;
  border-left: 1px dashed #4b465c;
  position: relative;
  padding-left: 20px;
  // margin-left: 10px;

  &:last-child {
    border: 0px;
    padding-bottom: 0;
  }

  &:before {
    content: '';
    width: 15px;
    height: 15px;
    background: #db4437;
    box-shadow: 0px 0px 0px 4px rgba(234, 84, 85, 0.1);
    border-radius: 50%;
    position: absolute;
    left: -8px;
    top: 0px;
  }
}

.mileage-moving .title {
  font-weight: 400;
  font-size: 10px;
}

.mileage-moving .subtitle {
  font-weight: 600;
  font-size: 12px;
}

.toggle-button {
  position: absolute;
  bottom: 220px;
  right: 3px;
  z-index: 99999;
}

.toggle-sidebar {
  background: #1da1f2;
  border-radius: 4px 4px 0px 0px;
  border: none;
}

.toggle-info {
  // background: #fff;
  background: #f8f7fa;
  border-radius: 6px;
  border: none;
  color: #4b465c;
  font-weight: 600;
  // box-shadow: 0px -2px 3px 3px rgba(165, 163, 174, 0.3);
}

.toggle-info .info-button {
  border-radius: 12px;
}

.toggle-sidebar img {
  transition: 300ms linear;
  transform: rotate(0deg);
}

.toggle-sidebar.opened img {
  transition: 300ms linear;
  transform: rotate(180deg);
}

.bottom-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  // height: 202px;
  height: auto;
  // background-color: #ddd;
  transition: all 0.3s ease-in-out;
  z-index: 9999;
}

.content-bottom-bar {
  background-color: #fff;
  height: 220px;
}

.bottom-bar.active {
  bottom: -220px;
}

// button-nav CSS

.activeBtn {
  background: #1da1f2 !important;
  color: #fff;
  font-weight: 600;
  outline: none;
}

.button-nav .btn {
  background: #f8f7fa;
  padding: 4px 16px 4px 16px;
  outline: none !important;
}

.btn-all {
  border-radius: 6px 0 0 6px;
}

.btn-speed {
  border-left: 1px solid #d0d0d0;
  border-right: 1px solid #d0d0d0;
  border-radius: 0;
}

.btn-fuel {
  // border-right: 1px solid #d0d0d0;
  // border-radius: 0;
  border-radius: 0 6px 6px 0;
}

// .btn-temp {
//   border-radius: 0 6px 6px 0;
// }

// range CSS

.range {
  background-color: #f8f7fa;
  // width: 600px;
  width: 55.857rem;
  // box-shadow: 0px 2px 4px rgba(165, 163, 174, 0.3);
  border-radius: 12px;
  height: 30px;
}

:where(.slider-wrapper, .slider) {
  width: 100%;
}

.range-container {
  width: 100%;
  margin: 0 auto;
}

.btn-play {
  background: none;
  border: none;
}

.btn-play:active img {
  box-shadow: 0px 2px 4px rgba(165, 163, 174, 0.3);
  border-radius: 50%;
}

.btn-next-track {
  background: none;
  border: none;
}

.btn-next-track:active {
  box-shadow: 0px 2px 4px rgba(165, 163, 174, 0.3);
  border-radius: 50%;
}

.m-number {
  font-weight: 600;
}

.polygone-wrapper {
  display: flex;
  flex-direction: column;
  margin: 5px 0 0 10px;
}

.btn_poi {
  width: 40px;
  height: 40px;
  background: #ffffff;
  box-shadow: 0px 2px 4px rgba(165, 163, 174, 0.3);
  border-radius: 8px;
  border: none;
  margin: 4px 0 4px 0;
}
</style>
